import i18nFactory from '@yandex-int/i18n';

import { selectRegionsEditor } from '../../selectors/groupEdit/group/group';
import { selectRegionsSearchEditorValue } from '../../selectors/regionsSearchEditor/regionsSearchEditor';
import { selectRegionsTransformEditorValue } from '../../selectors/regionsTransformEditor/regionsTransformEditor';
import { GdUpdateAdGroupRegionsActionInput } from '../../typings/graphql-grid';
import { RegionsTransformEditorState } from '../../typings/regionsTransformEditor';
import { State } from '../../typings/state';
import { GroupsHelpers } from '../GroupsHelpers/GroupsHelpers';

import * as keyset from './RegionsTransformEditorHelper.i18n';
const i18n = i18nFactory(keyset);

export const TOP_REGIONS_COUNT_FOR_REGIONS_TRANSFORM = 3;

export const getDefaultRegionsTransformEditorState = (): RegionsTransformEditorState => {
    return {
        isOpened: false,
        typeSelectedRegionsTransform: GdUpdateAdGroupRegionsActionInput.REPLACE,
        isLoading: false,
        isQuickSelectItemsLoading: false,
        campaignsIds: [],
        groupsIds: [],
        errors: undefined
    };
};

export const getRegionsEditorIdForRegionsTransform = (
    editorId: string,
    type: GdUpdateAdGroupRegionsActionInput
): string => {
    return `${editorId}-mass-action-regions-transform-${type}`;
};

export const isRegionsTransformApplyAllowed = (state: State, editorId: string): boolean => {
    const editorData = selectRegionsTransformEditorValue(state, editorId);
    const { typeSelectedRegionsTransform } = editorData;
    const internalEditorId = getRegionsEditorIdForRegionsTransform(editorId, editorData.typeSelectedRegionsTransform);

    switch (typeSelectedRegionsTransform) {
        case GdUpdateAdGroupRegionsActionInput.REPLACE:
            const regionsEditor = selectRegionsEditor(state, internalEditorId);

            return regionsEditor && Object.keys(regionsEditor.selectedMap).length > 0;
        case GdUpdateAdGroupRegionsActionInput.ADD:
        case GdUpdateAdGroupRegionsActionInput.REMOVE:
            const regionsSearchEditor = selectRegionsSearchEditorValue(state, internalEditorId);

            return regionsSearchEditor && regionsSearchEditor.selectedRegions.length > 0;
        default:
            return false;
    }
};

export const getNotificationMessageForRegionsTransformEditor = (
    countGroups: number,
    countSuccessGroups: number,
    hasLink: boolean
): string => {
    if (countGroups === 0) {
        return i18n('regions-transform-error-for-none-groups');
    }

    if (countGroups === countSuccessGroups) {
        if (countGroups === 1) {
            return i18n('regions-transform-full-success-one');
        }

        return i18n('regions-transform-full-success-many');
    }

    if (countSuccessGroups === 0) {
        if (countGroups === 1) {
            return i18n('regions-transform-full-error-one');
        }

        return i18n('regions-transform-full-error-many');
    }

    return hasLink
        ? i18n('regions-transform-partial-success-with-link', {
              count: countSuccessGroups,
              total: countGroups
          })
        : i18n('regions-transform-partial-success', {
              count: countSuccessGroups,
              total: countGroups
          });
};

export const getHintCountGroupsAndCampaignsForRegionsTransformEditor = (
    countCampaigns: number,
    countGroups: number
): string => {
    if (countGroups === 0) {
        return i18n('regions-transform-hint-count-campaigns', {
            count: countCampaigns
        });
    }

    return GroupsHelpers.getHintCountForEditGroupsAndCampaigns(countCampaigns, countGroups);
};
